<template>
  <a-layout style="height: 100%">
    <drawer v-if="isMobile" :openDrawer="collapsed" @change="onDrawerChange">
      <!--<sider-menu :theme="theme" :menuData="menuData" :collapsed="false" :collapsible="false" @menuSelect="onMenuSelect"/>-->
    </drawer>
    <sider-menu
      :theme="theme"
      v-else-if="layout === 'side'"
      :menuData="menuData"
      :collapsed="collapsed"
      :collapsible="true"
      @toggleCollapse="toggleCollapse"
    />
    <drawer :open-drawer="settingBar" placement="right">
      <setting />
    </drawer>
    <a-layout :style="{ paddingLeft: paddingLeft }">
      <global-header :menuData="menuData" :collapsed="collapsed" />
      <a-layout-content
        class="page-content-wrap"
        :style="{ height: minHeight }"
        style="overflow: auto; margin-top: 60px"
      >
        <!-- :class="fixHeader ? 'fixed-header-content' : null"> -->
        <slot></slot>
      </a-layout-content>
    </a-layout>
    <audio ref="bjaudio" loop>
      <source src="@/assets/audio/bj2.mp3" type="audio/mpeg" />
    </audio>
    <router-link :to="{ path: '/bigscreen' }" class="bigScreenData"
      >大屏展示</router-link
    >
    <div class="bj-wrap" v-show="isAlarm">
      <div class="image-wrap">
        <img
          :title="'告警记录'"
          src="@/assets/imgs/bj1.gif"
          @click="handleAlarmRecordShow"
        />
      </div>
      <span
        v-show="!isPlay"
        :title="'取消静音'"
        class="iconfont"
        style="color: #aaa; font-size: 20px"
        @click="playOrpause"
        >&#xe61e;</span
      >
      <span
        v-show="isPlay"
        :title="'设置静音'"
        class="iconfont"
        style="color: #aaa; font-size: 20px"
        @click="playOrpause"
        >&#xe62c;</span
      >
    </div>
    <AlarmRecord
      :alarmRecordVisiable="alarmRecordVisiable"
      @close="handleAlarmRecordClose"
    />
  </a-layout>
</template>

<script>
import GlobalHeader from "./GlobalHeader";
// import GlobalFooter from './GlobalFooter'
import Drawer from "~/tool/Drawer";
import SiderMenu from "~/menu/SiderMenu";
import Setting from "~/setting/Setting";
import { mapState, mapMutations } from "vuex";
import { triggerWindowResizeEvent } from "utils/common";
import AlarmRecord from "./AlarmRecord";
import monitorType from "../business/monitor/monitorType";
const minHeight = window.innerHeight - 59; //- 24 - 66

let menuData = [];

export default {
  name: "GlobalLayout",
  components: { Setting, SiderMenu, Drawer, GlobalHeader, AlarmRecord },
  data() {
    return {
      minHeight: minHeight + "px",
      collapsed: false,
      menuData: menuData,
      interval: null,
      isAlarm: false,
      isPlay: true,
      alarmRecordVisiable: false,
      alarmInterval: null,
      oldalarm: [],
    };
  },
  computed: {
    paddingLeft() {
      return this.fixSiderbar && this.layout === "side" && !this.isMobile
        ? `${this.sidebarOpened ? 256 : 80}px`
        : "0";
    },
    ...mapState({
      sidebarOpened: (state) => state.setting.sidebar.opened,
      isMobile: (state) => state.setting.isMobile,
      theme: (state) => state.setting.theme,
      layout: (state) => state.setting.layout,
      copyright: (state) => state.setting.copyright,
      fixSiderbar: (state) => state.setting.fixSiderbar,
      fixHeader: (state) => state.setting.fixHeader,
      settingBar: (state) => state.setting.settingBar.opened,
    }),
  },
  watch: {
    isAlarm() {
      this.isPlay = this.isAlarm;
      if (this.isAlarm) {
        this.$refs.bjaudio.play();
      } else {
        this.$refs.bjaudio.pause();
      }
    },
  },
  mounted() {
    this.getAlarmRecordData();
    window.addEventListener("resize", function () {
      window.screenHeight = document.body.clientHeight;
      this.minHeight = window.screenHeight - 59 + "px";
    });
  },
  methods: {
    ...mapMutations({ setSidebar: "setting/setSidebar" }),
    playOrpause() {
      this.isPlay = !this.isPlay;
      if (this.isPlay) {
        this.$refs.bjaudio.play();
      } else {
        this.$refs.bjaudio.pause();
      }
    },
    handleAlarmRecordShow() {
      this.alarmRecordVisiable = true;
    },
    handleAlarmRecordClose() {
      this.alarmRecordVisiable = false;
    },
    toggleCollapse() {
      this.collapsed = !this.collapsed;
      this.setSidebar(!this.collapsed);
      triggerWindowResizeEvent();
    },
    onDrawerChange(show) {
      this.collapsed = show;
    },
    onMenuSelect() {
      this.toggleCollapse();
    },
    arrDifferent(arr1, arr2) {
      if (arr1.length > arr2.length) {
        return false;
      } else {
        let set = new Set(arr2);
        let oriSetSize = set.size;
        arr1.forEach((item) => {
          set.add(item);
        });
        if (set.size > oriSetSize) {
          return true;
        } else {
          return false;
        }
      }
    },
    getAlarmRecordData() {
      //获取报警状态
      let self = this;
      this.$get("/monitor/monitorAlarm").then((r) => {
        // console.log("ba", r.data);
        let alarm = r.data;
        if (alarm.length == 0) {
          this.isAlarm = false;
          this.oldalarm = alarm;
        } else if (this.oldalarm.length == 0 && alarm.length > 0) {
          this.isAlarm = true;
          this.isPlay = true;
          this.$refs.bjaudio.play();
          this.oldalarm = alarm;
        } else if (this.oldalarm.length > 0 && alarm.length > 0) {
          let status = this.arrDifferent(this.oldalarm, alarm);
          if (status) {
            this.isAlarm = true;
            this.isPlay = true;
            this.$refs.bjaudio.play();
            this.oldalarm = alarm;
          }
          if (alarm.length > this.oldalarm.length) {
            console.log("新增判断", alarm.length, this.oldalarm.length);
            this.isAlarm = true;
            this.isPlay = true;
            this.$refs.bjaudio.play();
            this.oldalarm = alarm;
          }
          console.log("status", status);
          console.log(
            "长度",
            "alarm" + alarm.length,
            "oldalarm" + this.oldalarm.length
          );
        } else {
          this.isAlarm = false;
          console.log("else");
        }
        if (!this.interval) {
          this.interval = setInterval(() => {
            self.getAlarmRecordData();
          }, monitorType.LOOP_INTERVAL);
        }
      });
    },
  },
  beforeCreate() {
    let routers = this.$db.get("USER_ROUTER");
    // console.log(routers);
    menuData = routers
      .find((item) => item.path === "/")
      .children.filter((menu) => {
        let meta = menu.meta;
        if (typeof meta.isShow === "undefined") {
          return true;
        } else return meta.isShow;
      });
  },
  beforeDestroy() {
    clearInterval(this.interval);
    this.interval = null;
    this.$refs.bjaudio.pause();
  },
};
</script>

<style lang="less" scoped>
.setting {
  background-color: #1890ff;
  color: #fff;
  border-radius: 5px 0 0 5px;
  line-height: 40px;
  font-size: 22px;
  width: 40px;
  height: 40px;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
}
.fixed-header-content {
  // margin: 76px 12px 0 !important;
  margin: 60px 0 0 !important;
}
.copyright {
  position: relative;
}
.copyright div {
  height: 80px;
}
.bigScreen {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 256px;
  line-height: 60px;
  z-index: 9999;
  text-align: center;
  background-color: #393e46;
  .bigScreen-btn {
    width: 100px;
    line-height: 40px;
    text-align: center;
    border: 1px solid #888;
    color: #999;
    padding: 3px 5px;
    border-radius: 2px;
  }
}
@-webkit-keyframes mymove {
  0% {
    opacity: 0.8;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 0.8;
  }
}
@-moz-keyframes mymove {
  0% {
    opacity: 0.8;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 0.8;
  }
}
.bigScreenData {
  z-index: 999999;
  position: fixed;
  top: 12px;
  right: 260px;
  width: 80px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.647058823529412);
  border: rgba(153, 153, 153, 1) 1px solid;
  border-radius: 10px;
  font-family: "Arial Normal", "Arial";
  font-weight: 400;
  font-style: normal;
  &:hover {
    cursor: pointer;
  }
}
.bj-wrap {
  position: fixed;
  top: 0;
  // left: 300px;
  right: 150px;
  width: 100px;
  height: 59px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  // flex-direction: column;
  .image-wrap {
    width: 55px;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    & img {
      width: 35px;
      height: 35px;
      // animation:imageChange 1s infinite;
      // -webkit-animation:imageChange 1s infinite;
      cursor: pointer;
    }
  }
  & span {
    cursor: default;
  }
}
@keyframes imageChange {
  from {
    width: 35px;
    height: 35px;
  }
  50% {
    width: 50px;
    height: 50px;
  }
  100% {
    width: 35px;
    height: 35px;
  }
}
@-webkit-keyframes imageChange {
  from {
    width: 50px;
    height: 50px;
  }
  50% {
    width: 35px;
    height: 35px;
  }
  100% {
    width: 50px;
    height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/GlobalLayout.vue